import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-6292c683")

_pushScopeId("data-v-6292c683")
const _hoisted_1 = { class: "upload-overlay" }
const _hoisted_2 = { class: "actions-container" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Publish ")
const _hoisted_4 = {
  key: 0,
  class: "published"
}
const _hoisted_5 = {
  key: 0,
  class: "attribute-line"
}
const _hoisted_6 = /*#__PURE__*/_createVNode("span", { class: "label" }, "Published status", -1)
const _hoisted_7 = { class: "value" }
const _hoisted_8 = {
  key: 1,
  class: "attribute-line"
}
const _hoisted_9 = /*#__PURE__*/_createVNode("span", { class: "label" }, "Published date", -1)
const _hoisted_10 = { class: "value" }
const _hoisted_11 = { class: "attribute-line" }
const _hoisted_12 = /*#__PURE__*/_createVNode("span", { class: "label" }, "Edit date", -1)
const _hoisted_13 = { class: "value" }
const _hoisted_14 = { class: "attribute-line" }
const _hoisted_15 = /*#__PURE__*/_createVNode("span", { class: "label" }, "Creation date", -1)
const _hoisted_16 = { class: "value" }
const _hoisted_17 = { class: "attribute-line" }
const _hoisted_18 = /*#__PURE__*/_createVNode("span", { class: "label" }, "Editor", -1)
const _hoisted_19 = { class: "value" }
const _hoisted_20 = { class: "attribute-line" }
const _hoisted_21 = /*#__PURE__*/_createVNode("span", { class: "label" }, "Creator", -1)
const _hoisted_22 = { class: "value" }
const _hoisted_23 = {
  key: 2,
  class: "attribute-line"
}
const _hoisted_24 = /*#__PURE__*/_createVNode("span", { class: "label" }, "Published message", -1)
const _hoisted_25 = { class: "value" }
const _hoisted_26 = {
  key: 3,
  class: "attribute-line"
}
const _hoisted_27 = /*#__PURE__*/_createVNode("span", { class: "label" }, "Number of splits", -1)
const _hoisted_28 = { class: "value" }
const _hoisted_29 = {
  key: 4,
  class: "attribute-line"
}
const _hoisted_30 = /*#__PURE__*/_createVNode("span", { class: "label" }, "Number of Restricted Areas", -1)
const _hoisted_31 = { class: "value" }
const _hoisted_32 = /*#__PURE__*/_createVNode("div", { slot: "header" }, "Upload overlay", -1)
const _hoisted_33 = /*#__PURE__*/_createVNode("div", { slot: "content" }, [
  /*#__PURE__*/_createTextVNode("You're going to upload this overlay."),
  /*#__PURE__*/_createVNode("br"),
  /*#__PURE__*/_createTextVNode("Could you confirm ?")
], -1)
const _hoisted_34 = /*#__PURE__*/_createTextVNode("Cancel")
const _hoisted_35 = /*#__PURE__*/_createTextVNode("Ok")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx, _cache) => {
  const _component_calcite_button = _resolveComponent("calcite-button")
  const _component_calcite_modal = _resolveComponent("calcite-modal")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      (_ctx.isEditor && _ctx.overlay?.RoutingServiceVersion != 'V8')
        ? (_openBlock(), _createBlock(_component_calcite_button, {
            key: 0,
            "icon-end": "upload",
            onClick: _cache[1] || (_cache[1] = $event => {_ctx.showModal = !_ctx.showModal; _ctx.isClickable = !_ctx.isClickable}),
            color: "red",
            style: {"margin-right":"10px"},
            class: {'clickable': _ctx.isDisable}
          }, {
            default: _withId(() => [
              _hoisted_3
            ]),
            _: 1
          }, 8, ["class"]))
        : _createCommentVNode("", true)
    ]),
    (!_ctx.showModal && _ctx.isPublished != '')
      ? (_openBlock(), _createBlock("div", _hoisted_4, [
          _createVNode("span", null, _toDisplayString(_ctx.isPublished), 1)
        ]))
      : _createCommentVNode("", true),
    _createVNode("div", null, [
      (_ctx.overlay?.RoutingServiceVersion != 'V8')
        ? (_openBlock(), _createBlock("div", _hoisted_5, [
            _hoisted_6,
            _createVNode("span", _hoisted_7, _toDisplayString(_ctx.publishedStatus(_ctx.overlay?.PublishedStatus)), 1)
          ]))
        : _createCommentVNode("", true),
      (_ctx.overlay?.RoutingServiceVersion != 'V8')
        ? (_openBlock(), _createBlock("div", _hoisted_8, [
            _hoisted_9,
            _createVNode("span", _hoisted_10, _toDisplayString(_ctx.publishedDate), 1)
          ]))
        : _createCommentVNode("", true),
      _createVNode("div", _hoisted_11, [
        _hoisted_12,
        _createVNode("span", _hoisted_13, _toDisplayString(_ctx.editDate), 1)
      ]),
      _createVNode("div", _hoisted_14, [
        _hoisted_15,
        _createVNode("span", _hoisted_16, _toDisplayString(_ctx.creationDate), 1)
      ]),
      _createVNode("div", _hoisted_17, [
        _hoisted_18,
        _createVNode("span", _hoisted_19, _toDisplayString(_ctx.overlay?.EditedBy), 1)
      ]),
      _createVNode("div", _hoisted_20, [
        _hoisted_21,
        _createVNode("span", _hoisted_22, _toDisplayString(_ctx.overlay?.CreatedBy), 1)
      ]),
      (_ctx.overlay?.RoutingServiceVersion != 'V8')
        ? (_openBlock(), _createBlock("div", _hoisted_23, [
            _hoisted_24,
            _createVNode("span", _hoisted_25, _toDisplayString(_ctx.publishedMessage), 1)
          ]))
        : _createCommentVNode("", true),
      (_ctx.overlay?.RoutingServiceVersion != 'V8')
        ? (_openBlock(), _createBlock("div", _hoisted_26, [
            _hoisted_27,
            _createVNode("span", _hoisted_28, _toDisplayString(_ctx.overlay?.NumberSplitOverlays), 1)
          ]))
        : _createCommentVNode("", true),
      (_ctx.overlay?.RoutingServiceVersion === 'V8')
        ? (_openBlock(), _createBlock("div", _hoisted_29, [
            _hoisted_30,
            _createVNode("span", _hoisted_31, _toDisplayString(_ctx.restrictedAreasSize.size), 1)
          ]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.showModal)
      ? (_openBlock(), _createBlock(_component_calcite_modal, {
          key: 1,
          width: "s",
          active: "",
          "disable-close-button": "",
          "disable-outside-close": ""
        }, {
          default: _withId(() => [
            _hoisted_32,
            _hoisted_33,
            _createVNode(_component_calcite_button, {
              slot: "back",
              color: "light",
              onClick: _cache[2] || (_cache[2] = $event => {_ctx.showModal = !_ctx.showModal; _ctx.isClickable = !_ctx.isClickable})
            }, {
              default: _withId(() => [
                _hoisted_34
              ]),
              _: 1
            }),
            _createVNode(_component_calcite_button, {
              slot: "primary",
              color: "blue",
              onClick: _cache[3] || (_cache[3] = $event => {_ctx.onUploadOverlay(); _ctx.showModal = !_ctx.showModal})
            }, {
              default: _withId(() => [
                _hoisted_35
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
})